<template>
    <v-layout row wrap class="mt-4 pl-4">
        <v-flex xs6 class="pl-1">
            <div class="fingerprint">fingerprint 1</div>
            <v-layout row wrap class="pl-4">
                <v-flex xs2 v-for="(fingerprint,index) in fingerprints_1" :key="index">
                    <file-display :src="fingerprint"/>
                </v-flex>
            </v-layout>
        </v-flex>
        <v-flex xs6 >
            <div class="fingerprint">fingerprint 2</div>
            <v-layout row wrap class="pl-2">
                <v-flex xs2 v-for="(fingerprint,index) in fingerprints_2" :key="index">
                    <file-display :src="fingerprint"/>
                </v-flex>
            </v-layout>
        </v-flex>

    </v-layout>
</template>

<script>
    import FileDisplay from "../../components/FileDisplay";
    // import HeaderText from "../../components/HeaderText";

    export default {
        name: "FingerPrint",
        components: {FileDisplay},
        props: ['fingerprints_1', 'fingerprints_2'],
        mounted() {
            console.log(this.props);
        }
    }
</script>

